import Joi from '@hapi/joi'

export const MobileDeviceConfigurationSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Select Operation Entity`,
        "any.required": `Operation Entity required`
    }),
    routeID: Joi.string().allow('').optional().label("Route").messages({
        "any.invalid": `Select Division`,
        "any.required": `Division required`
    }),   
}
